var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-combobox',{attrs:{"value":_vm.selectedData,"items":_vm.data,"item-text":_vm.itemText,"item-value":_vm.itemValue,"multiple":_vm.multiple,"label":_vm.label,"chips":_vm.chips,"return-object":_vm.returnObject,"deletable-chips":"","dense":""},on:{"change":_vm.onChange,"input":_vm.inputChecked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }